window['$'] = window['jQuery'] = require("../../../static/js/tagging-page/jquery-2.1.4.min.js");
window['Spinner'] = require("../../../static/js/spin.min.js");
require("../../../static/js/spinner.js");
require("../../../static/widgets/iframe/iframe.js");
